import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';
import { styled } from '@mui/material/styles';

import { colors, devices } from 'styles';

export const AILSV2Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 112px 0 155px;

  @media (${devices.sm}) {
    padding: 112px 0 220px;
  }
`;

export const ListItem = styled('li')`
  font-size: 16px;
  line-height: 150%;
  color: ${colors.white};
`;

export const FirstSectionWrapper = styled(Box)`
  display: flex;
  justify-content: inherit;
  width: 100%;
  flex-direction: column;
  margin-bottom: 120px;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const FirstSectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  color: ${colors.white};
  max-width: 100%;
  margin-right: 0px;
  margin-bottom: 32px;
  width: 100%;

  @media (${devices.sm}) {
    margin-bottom: 0px;
    margin-right: 16px;

    width: 373px;
  }

  @media (${devices.md}) {
    margin-right: 60px;
    font-size: 40px;
    width: 100%;
    max-width: 560px;
  }
`;

export const FirstSectionDescription = styled(Typography)`
  font-size: 18px;
  line-height: 150%;
  color: ${colors.white};
  width: 100%;

  @media (${devices.sm}) {
    max-width: 377px;
  }

  @media (${devices.md}) {
    max-width: 560px;
  }
`;

export const IconWrapper = styled(Box)`
  & img {
    display: block;
  }
`;

export const ItemTitle = styled(Typography)`
  font-size: 24px;
  line-height: 140%;
  color: ${colors.white};
  font-weight: 700;
  margin: 24px 0;
`;

export const ItemDescription = styled(Typography)`
  font-size: 16px;
  line-height: 150%;
  color: ${colors.white};
`;

export const ItemWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 420px;

  @media (${devices.sm}) {
    max-width: 369px;
  }

  @media (${devices.md}) {
    max-width: 264px;
  }
`;

export const SecondSectionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (${devices.md}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ItemsWrapper = styled(Box)`
  display: flex;
  width: 100%;
  margin-top: 48px;
  flex-direction: column;
  gap: 48px;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
  }

  @media (${devices.md}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
    margin-top: 0;
    margin-left: 48px;
  }
`;

export const SecondSectionTitle = styled(Box)`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 24px;
  color: ${colors.white};
  width: 100%;
  max-width: 100%;
`;
